export const updateTaskAppointmentFrag = `
    id
`;

export const createTaskAppointmentFrag = `
    id
`;
